<div *ngIf="loading" class="screen_loader animate__animated absolute inset-0 z-[35] grid place-content-center bg-[#fafafa] opacity-65 dark:bg-[#060818]">
  <img class="ml-[5px] h-auto w-20 flex-none" src="/assets/images/loader.svg" alt="" />
</div>

<div>
  <div class="relative">
    <div class="panel border-[#e0e6ed] px-0 pb-1.5 dark:border-[#1b2e4b]">
      <div class="datatable invoice-table px-5">
        <div class="mb-4.5 flex flex-col gap-5 md:flex-row md:items-center">
          <app-search-input (searchChanged)="setSearchText($event)"></app-search-input>
        </div>

        <app-global-table-filters [filterType]="filterType" [total]="total" [rejected]="invalidCount" (selectionChange)="onSelectionChangeUnified($event.filterType)"></app-global-table-filters>

        <ng-datatable
          #datatable
          [rows]="items"
          [columns]="cols"
          [sortable]="true"
          [isServerMode]="true"
          [page]="pageNumber"
          [search]="search"
          [pageSize]="pageSize"
          [totalRows]="totalRows"
          [sortColumn]="sortColumn"
          [sortDirection]="sortDirection"
          (changeServer)="changeServer($event)"
          skin="whitespace-nowrap bh-table-hover"
          [paginationInfo]="'paginationInfoLabel' | translate"
        >
          <ng-template slot="agencyName" let-value="data">
            <div class="flex gap-2">
              {{ value.agencyName ?? "/" }}
              <div *ngIf="value.rejectComment" [ngxTippy]="value.rejectComment" class="cursor-pointer font-bold">- {{ "instance_request.comment" | translate }}</div>
            </div>
          </ng-template>
          <ng-template slot="phone" let-value="data">
            {{ value.phone ?? "/" }}
          </ng-template>
          <ng-template slot="actions" let-value="data">
            <div class="flex w-max items-center justify-between">
              <div hlMenu class="dropdown">
                <a hlMenuButton href="javascript:;">
                  <icon-horizontal-dots class="rotate-90 opacity-70" />
                </a>
                <div #dropdownPlaceholder *hlMenuItems>
                  <app-message-portal #messagePortalComponent @toggleAnimation (portalAttached)="onPortalAttached()">
                    <div *ngIf="value.state === InstanceRequestState.Pending">
                      <li>
                        <a href="javascript:;" *hlMenuItem="let menuItem" (click)="openApproveModal(value.id)">
                          <icon-circle-check class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2" />
                          {{ "contract.approve" | translate }}
                        </a>
                      </li>
                      <li>
                        <a href="javascript:;" *hlMenuItem="let menuItem" (click)="openRejectModal(value.id)">
                          <icon-x-circle class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2" />
                          {{ "instance_request.reject" | translate }}
                        </a>
                      </li>
                    </div>

                    <li *ngIf="value.state === InstanceRequestState.Rejected">
                      <a href="javascript:;" *hlMenuItem="let menuItem" (click)="openDeleteModal(value.id)">
                        <icon-trash class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2" />
                        {{ "delete_quick_label" | translate }}
                      </a>
                    </li>
                  </app-message-portal>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-datatable>
      </div>
    </div>
  </div>
</div>

<ng-template #approveModalTemplate>
  <div class="flex flex-col p-4">
    <div class="!pb-5 text-xl">{{ "instance_request.approve_title" | translate }}</div>
    <form [formGroup]="approveForm" class="text-sm" (ngSubmit)="submitApproveForm()">
      <div class="mb-5" [ngClass]="approveForm.controls['agencyName'].touched ? (approveForm.controls['agencyName'].errors ? 'has-error' : 'has-success') : ''">
        <label for="agencyName">{{ "agencyName" | translate }}</label>
        <input id="surname" type="text" placeholder="{{ 'enter_agencyName' | translate }}" class="form-input" formControlName="agencyName" />
        <small class="text-danger" *ngIf="approveForm.controls['agencyName'].errors && approveForm.controls['agencyName'].touched">
          {{ "please_provide_agencyName" | translate }}
        </small>
      </div>
      <div class="mb-5" [ngClass]="approveForm.controls['phoneNumber'].touched ? (approveForm.controls['phoneNumber'].errors ? 'has-error' : 'has-success') : ''">
        <label for="phoneNumber">{{ "customers.phone" | translate }}</label>
        <input id="surname" type="text" placeholder="{{ 'phone_input' | translate }}" class="form-input" formControlName="phoneNumber" />
        <small class="text-danger" *ngIf="approveForm.controls['phoneNumber'].errors && approveForm.controls['phoneNumber'].touched">
          {{ "please_provide_phone" | translate }}
        </small>
      </div>
      <div class="mb-5">
        <label for="domainName" [ngClass]="approveForm.controls['domainName'].touched ? (approveForm.controls['domainName'].errors ? 'has-error' : 'has-success') : ''">Domain Name</label>
        <div class="flex">
          <div
            class="flex items-center justify-center border border-[#e0e6ed] bg-[#eee] px-3 font-semibold dark:border-[#17263c] dark:bg-[#1b2e4b] ltr:rounded-l-md ltr:border-r-0 rtl:rounded-r-md rtl:border-l-0"
          >
            https://
          </div>
          <input id="domainName" formControlName="domainName" type="text" placeholder="tourisagent" (blur)="validateDomain()" class="form-input ltr:rounded-none rtl:rounded-none" />
          <div
            class="flex items-center justify-center border border-[#e0e6ed] bg-[#eee] px-3 font-semibold dark:border-[#17263c] dark:bg-[#1b2e4b] ltr:rounded-r-md ltr:border-l-0 rtl:rounded-l-md rtl:border-r-0"
          >
            .turistagent.com
          </div>
        </div>
        <small class="text-danger" *ngIf="approveForm.controls['domainName'].errors && approveForm.controls['domainName'].touched">
          {{ "please_provide_domainName" | translate }}
        </small>
        <small class="text-danger" *ngIf="approveForm.get('domainName')?.errors?.['invalidDomainName'] && approveForm.get('domainName')?.touched"> Only letters and dashes are allowed. </small>
        <small class="text-danger" *ngIf="approveForm.get('domainName')?.errors?.['domainTaken'] && approveForm.get('domainName')?.touched"> This domain is already taken. </small>
      </div>
      <div class="mb-5" [ngClass]="approveForm.controls['tier'].touched ? (approveForm.controls['tier'].errors ? 'has-error' : 'has-success') : ''">
        <label for="tier">Select Tier</label>
        <ng-select
          [items]="options$ | async"
          placeholder="Select Tier"
          [searchable]="false"
          [clearable]="false"
          class="custom-multiselect"
          bindLabel="title"
          bindValue="id"
          labelForId="tier"
          [formControlName]="'tier'"
          appendTo="body"
        >
        </ng-select>
        <small class="text-danger" *ngIf="approveForm.controls['tier'].errors && approveForm.controls['tier'].touched">
          {{ "please_provide_phone" | translate }}
        </small>
      </div>
      <div class="mt-8 flex items-center justify-end ltr:text-right rtl:text-left">
        <button type="button" *ngIf="!isLoading" class="btn btn-outline-danger" (click)="closeApproveModal()">
          {{ "cancel" | translate }}
        </button>
        <button type="submit" *ngIf="!isLoading" class="btn btn-primary ltr:ml-4 rtl:mr-4">
          {{ "submit" | translate }}
        </button>
        <button *ngIf="isLoading" type="button" class="btn btn-primary ltr:ml-4 rtl:mr-4" [disabled]="isLoading">
          <span class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-l-transparent align-middle ltr:mr-4 rtl:ml-4"></span>Loading
        </button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #rejectModalTemplate>
  <div class="flex flex-col p-4">
    <div class="!pb-5 text-xl">{{ "instance_request.reject_title" | translate }}</div>
    <div class="mb-5">
      <label for="rejectComment">{{ "instance_request.comment" | translate }}</label>
      <textarea name="rejectComment" [(ngModel)]="rejectComment" [placeholder]="'instance_request.enter_comment' | translate" class="form-input h-40"></textarea>
      <div class="mt-8 flex items-center justify-end ltr:text-right rtl:text-left">
        <button type="button" *ngIf="!isLoading" class="btn btn-outline-danger" (click)="closeRejectModal()">
          {{ "cancel" | translate }}
        </button>
        <button type="submit" *ngIf="!isLoading" class="btn btn-primary ltr:ml-4 rtl:mr-4" (click)="handleReject()">
          {{ "submit" | translate }}
        </button>
        <button *ngIf="isLoading" type="button" class="btn btn-primary ltr:ml-4 rtl:mr-4" [disabled]="isLoading">
          <span class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-l-transparent align-middle ltr:mr-4 rtl:ml-4"></span>Loading
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #deleteConfirmationTemplate>
  <div class="flex flex-col p-4">
    <div class="!pb-5 text-xl">{{ "instance_request.delete_title" | translate }}</div>
    <div>
      <span>{{ "instance_request.delete_info" | translate }} </span>
    </div>
    <div class="mt-4 flex justify-end">
      <button class="rounded-lg bg-gray-200 px-4 py-2 text-gray-800 hover:bg-gray-300" (click)="closeDeleteModal()">{{ "cancel" | translate }}</button>
      <button class="btn btn-danger ml-3" [disabled]="isLoadingDelete" (click)="handleDelete()">
        <ng-container *ngIf="isLoadingDelete; else alternateTranslation">
          <span class="inline-block h-3 w-3 animate-ping rounded-full bg-white ltr:mr-4 rtl:ml-4"></span>
          {{ "deleting" | translate }}
        </ng-container>
        <ng-template #alternateTranslation>
          {{ "delete_quick_label" | translate }}
        </ng-template>
      </button>
    </div>
  </div>
</ng-template>
